import { useState, useEffect } from "react";

export const useIsMobile = (mobileWidth = 480): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= mobileWidth);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, [mobileWidth]);

  return isMobile;
};

export default useIsMobile;
